export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_00.11404728.png";